import React from "react";
import { Button, BUTTON_SIZE, BUTTON_THEME } from "App/core/Button";
import { CommentBlockConfig } from "App/common/Comment/blocks";
import "./TrackCommentInput.scss";
import { useFocusedCard } from "App/common/useFocusedCard";
import { StickerIds, CommentBlock } from "@highnote/server/src/core/entities";
import { StickerSelectionDialog } from "../StickerSelectionDialog";
import { useNewCard } from "./useNewCard";

export const CommentButton = ({
  config,
}: {
  config: CommentBlockConfig<CommentBlock>;
}) => {
  const { focusedCardId } = useFocusedCard();
  const {
    addCard,
    isStickerSelectionDialogOpen,
    setIsStickerSelectionDialogOpen,
  } = useNewCard();

  const onClick = () => {
    if (config.id === "sticker") {
      setIsStickerSelectionDialogOpen(true);
      return;
    }

    addCard(config);
  };

  const onSelectSticker = async (props: {
    id?: StickerIds;
    imageUrl?: string;
  }) => {
    config.blockProps = props;

    await addCard({
      ...config,
      blockProps: props,
    });
  };

  /** omit text block once we have a proper text input */
  if (config.id === "text") {
    return null;
  }

  return (
    <>
      <Button
        disabled={!!focusedCardId}
        size={BUTTON_SIZE.LARGE}
        theme={BUTTON_THEME.ICON}
        onClick={onClick}
        aria-label={config.displayName}
        title={config.displayName}
      >
        <config.Icon />
      </Button>
      {isStickerSelectionDialogOpen && (
        <StickerSelectionDialog
          onClose={() => setIsStickerSelectionDialogOpen(false)}
          onSelect={onSelectSticker}
        />
      )}
    </>
  );
};
